module.exports = __webpack_public_path__ + "static/fast-9198b149024954b4e828705780e1ec8a.png";